import * as Dialog from '@radix-ui/react-dialog';
import { type ReactNode } from 'react';

/**
 * Modal — Studio Linen v1.0 (Radix Dialog 기반)
 *
 * 접근성 자동:
 *   - focus trap
 *   - Escape 닫기
 *   - aria-modal + aria-labelledby
 *   - 스크롤 lock
 *   - 외부 클릭 닫기 (옵션)
 *
 *   <Modal
 *     open={isOpen}
 *     onOpenChange={setOpen}
 *     title="인증서가 발급되었습니다"
 *     description="당신의 첫 인증서가 평생 보관됩니다."
 *     size="md"
 *     footer={<Button onClick={() => setOpen(false)}>닫기</Button>}
 *   >
 *     <p>본문...</p>
 *   </Modal>
 */
export interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /** Hide the close (×) button in top-right */
  hideClose?: boolean;
}

export function Modal({
  open, onOpenChange, title, description, children, footer,
  size = 'md', hideClose = false,
}: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="bq-modal__backdrop" />
        <Dialog.Content className={`bq-modal bq-modal--${size}`}>
          {!hideClose && (
            <Dialog.Close className="bq-modal__close" aria-label="Close">
              ×
            </Dialog.Close>
          )}
          {title && (
            <Dialog.Title className="bq-modal__title">{title}</Dialog.Title>
          )}
          {description && (
            <Dialog.Description className="bq-modal__description">
              {description}
            </Dialog.Description>
          )}
          {children && <div className="bq-modal__body">{children}</div>}
          {footer && <div className="bq-modal__footer">{footer}</div>}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
